export default __webpack_public_path__ + "static/media/Gloves of the Hell Walker (nm).39e8b5ed.jpg";